export default "__VITE_ASSET__7ae79d36__"